exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggle-container{display:grid;grid-template-columns:1fr 1fr}.toggle-container button{display:flex;align-items:center;justify-content:space-between;padding:18px;height:25px;width:80px;font-weight:400;font-size:12px;border:none;border-radius:3px;opacity:1;color:#fff;background:#9fa19e;transition:.25s ease-in}.toggle-container button:last-child{justify-self:end}.toggle-container button:hover:not(:disabled){background:#b15e5d}.toggle-container button:disabled{background:#bdbdbd}.toggle-container .next-button:not(:disabled){background:#f44336}@media(max-width:992px){.toggle-container{padding-inline:10px}}", ""]);

// exports
